@if (company) {
  <!-- Club Pro Upgrade Card - Only show for riding clubs without subscription -->
  @if (canUpgradeToPro()) {
    <div class="row d-flex mb-5">
      <div class="col-12">
        <div class="card bg-light-primary border border-primary border-dashed">
          <div class="card-body p-6">
            <div class="d-flex align-items-center">
              <div class="symbol symbol-50px me-5">
                <span class="symbol-label bg-primary">
                  <i class="fa fa-crown text-white fs-2"></i>
                </span>
              </div>
              <div class="flex-grow-1 me-4">
                <h4 class="fw-bold text-gray-900 mb-1">{{ 'companyProfile.subscription.upgradeTitle' | translate }}</h4>
                <p class="text-gray-600 fw-semibold mb-0">{{ 'companyProfile.subscription.upgradeDescription' | translate }}</p>
                <div class="d-flex flex-wrap mt-2">
                  <span class="badge badge-success me-2 mb-1">
                    <i class="fa fa-check me-1"></i>{{ 'companyProfile.subscription.featureMemberships' | translate }}
                  </span>
                  <span class="badge badge-success mb-1">
                    <i class="fa fa-check me-1"></i>{{ 'companyProfile.subscription.featureCompetitions' | translate }}
                  </span>
                </div>
              </div>
              <div class="text-end">
                <div class="fs-2 fw-bold text-primary mb-1">{{ CLUB_PRO_FEE }} kr/{{ 'companyProfile.subscription.year' | translate }}</div>
                <app-button
                  [label]="isUpgrading ? ('companyProfile.subscription.processing' | translate) : ('companyProfile.subscription.upgradeButton' | translate)"
                  [variant]="'primary'"
                  [size]="'md'"
                  [disabled]="isUpgrading"
                  (clicked)="upgradeToClubPro()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="row d-flex">
    <div class="col-lg-6 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">{{ 'companyProfile.overview.companyInfo' | translate }}</h3>
          </div>
          <app-button
            [iconClass]="'fa fa-edit fs-2'"
            [variant]="'primary'"
            [size]="'md'"
            (clicked)="openEditProfileModal()"
          />
        </div>
        <div class="card-body p-9">
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">{{ 'companyProfile.overview.companyName' | translate }}</label>
            <div class="col-lg-8">
              <span class="fw-bold fs-6 text-gray-800">{{ company.company_name }}</span>
            </div>
          </div>
          @if (company.organisation_number) {
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">{{ 'companyProfile.overview.organisationNumber' | translate }}</label>
              <div class="col-lg-8">
                <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ company.organisation_number }}</a>
              </div>
            </div>
          }
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">{{ 'companyProfile.overview.address' | translate }}</label>
            <div class="col-lg-8">
              <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ company.address }}, {{company.postal_code}} {{company.city}}, {{company.country}}</a>
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">{{ 'companyProfile.overview.active' | translate }}</label>
            <div class="col-lg-8">
              @if (company.active) {
                <span class="badge badge-success">{{ 'companyProfile.overview.active' | translate }}</span>
              } @else {
                <span class="badge badge-dark">{{ 'companyProfile.overview.inactive' | translate }}</span>
              }
            </div>
          </div>
          @if (hasProSubscription()) {
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">{{ 'companyProfile.subscription.subscriptionLabel' | translate }}</label>
              <div class="col-lg-8">
                <span class="badge badge-success">
                  <i class="fa fa-crown me-1"></i>{{ 'companyProfile.subscription.pro' | translate }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row d-flex">
    <div class="col-lg-12 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">{{ 'companyProfile.overview.description' | translate }}</h3>
          </div>
        </div>
        <div class="card-body p-9">
          @if (company.description) {
            <div [innerHTML]="company.description"></div>
          } @else {
            <div class="d-flex flex-column align-items-center justify-content-center py-10">
              <i class="fa fa-file-alt text-muted fs-3x mb-4"></i>
              <p class="text-muted mb-0">{{ 'companyProfile.overview.noDescription' | translate }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row d-flex">
    <div class="col-lg-12 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">{{ 'companyProfile.overview.images' | translate }}</h3>
          </div>
          <app-button
            [iconClass]="'fa fa-edit fs-2'"
            [variant]="'primary'"
            [size]="'md'"
            (clicked)="openEditImagesModal()"
          />
        </div>
        <div class="card-body p-9">
          @if (slides.length > 0) {
            <app-carouselorini
              [items]="slides"
              [autoCycle]="true"
              [interval]="8000"
              [showIndicators]="true"
              [showControls]="true"
            ></app-carouselorini>
          } @else {
            <div class="d-flex flex-column align-items-center justify-content-center py-10">
              <i class="fa fa-images text-muted fs-3x mb-4"></i>
              <p class="text-muted mb-0">{{ 'companyProfile.overview.noImages' | translate }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
